import { useMutation } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const useCheckClaimEligibility = () => {
  return useMutation({
    mutationFn: async ({ policyNumber }) => {
      const response = await apiClient.get('/policy/check-claim-eligibility', {
        params: {
          policy_number: policyNumber,
          claim_type: 'PWD',
        },
      });
      return response.data;
    },
  });
};

export { useCheckClaimEligibility };
